<div class="bouquet-arabe-details product-detail-container">
  <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.bouquet-arabe-header'"></app-tvshop-header>
  <div class="product-detail-content" #productdetailcontent>
    <app-product-detail-intro class="productDetailIntro"
                              [pack]="pack"
                              [titleKey]="'eos-tv-shop-ii.title.bouquet-arabe-details'"
                              [descriptionKey]="'eos-tv-shop-ii.text.bouquet-arabe-details'"
                              (emitOrderProduct)="openOrderModal($event)">
    </app-product-detail-intro>
    <app-product-detail-entertainment class="productDetailEntertainment"
                                      [hasLogo]="true"
                                      [pack]="pack"
                                      [componentName]="'channels'"
                                      [titleKey]="'eos-tv-shop-ii.title.bouquet-arabe-channels'"
                                      [descriptionKey]="'eos-tv-shop-ii.text.bouquet-arabe-channels'"
                                      (emitOrderProduct)="openOrderModal($event)">

    </app-product-detail-entertainment>
  </div>
  <app-arrow id="arrow_direction"></app-arrow>
  <app-ordering-modal-manager [order]="order"
                              #orderModal></app-ordering-modal-manager>
</div>
